// This file is generated at build time
const config = {
    imagePath: process.env.REACT_APP_IMAGE_PATH
  };
  
  export default config;
  